import React from 'react';

import { nameInitials } from 'utils/nameInitials';
import FormDrawer from '../form-drawer';
import { colorPalette } from 'data/colorPalette';

const ViewUserRoleModal = (props) => {
const {isOpen, setIsOpen, data: users} = props;

  const colorKeys = Object.keys(colorPalette);

    return (
        <FormDrawer display="center" size="xl" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="View Users in Role"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                <div>There are <span className='text-ep-primary-700 font-medium'>{users?.length} {users?.length > 1 ? ' Users' : ' User'}</span> with this role</div>
                
                <hr />
                    
                    <div>
                    {
                       users?.length > 0 ? users.map((user, idx) => {
                        const color = colorKeys[idx % colorKeys.length]; 

                            return (
                                <div key={idx} className='flex my-3 border-b p-3'>
                                    {user?.employer?.profileImage ?
                                    (<div className='flex justify-center w-12 h-12'>
                                            <img width='42' height='42' className="rounded-full object-cover" src={user?.employer?.profileImage} alt="user?" />
                                        </div>)
                                        :
                                        <div className={`p-3 w-12 h-12 rounded-full text-white`} style={{backgroundColor: colorPalette[color]}}>
                                            <div>{nameInitials(user?.firstName, user?.lastName)}</div>
                                        </div>
                                    }
                                    <div className='pl-3'>
                                        <div className='font-medium'>{user?.firstName + ' ' + user?.lastName}</div>
                                        <div className='text-ep-gray-500'>{user?.email}</div>
                                    </div>
                                </div>
                            );
                        }) : (
                            <div className='flex justify-center items-center h-32'> No users in this role</div>
                        )
                    }
                    </div>
                
                
                <div className="p-1 mt-8 flex justify-end space-x-3">
                    <div>
                        <button onClick={setIsOpen} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                            Close
                        </button>
                    </div>
                </div>
                
            </div>
        </FormDrawer>
  )
}

export default ViewUserRoleModal